<template>
<div
  class="relative flex"
  :class="{
    'justify-start': styles.button.alignment == 'left',
    'justify-end': styles.button.alignment == 'right',
    'justify-center': styles.button.alignment == 'center',
  }"
>
  <span
    v-if="
      !localValue ||
      (localValue && localValue === 0)
    "
    class="text-opacity-50 text-grey-700"
    >{{
      $t('frontend_groovemail_forms_step1_please_enter_button_text')
    }}</span>
    <div
      class="inline-block"
      :class="{'w-full': styles.button.alignment == 'full'}"
      :style="
        'max-width: 100%;' +
        'box-shadow:' + (styles.button.boxShadow ?? '') + ';' +
        'background:' + styles.button.backgroundColor + ';' +
        'margin:' + styles.button.margin + 'px;' +
        'padding: ' + styles.button.padding.join('px ') + 'px;' +
        'margin: ' + styles.button.margin.join('px ') + 'px;' +
        'border-width:' + styles.button.border?.width.join('px ') + 'px;' +
        'border-radius:' + styles.button.border?.radius.join('px ') + 'px;' +
        'border-color:' + styles.button.border?.color.join(' ') + ';' +
        'border-style:' + styles.button.border?.style.join(' ') + ';' +
        styles.button.customStyles ?? ''
      "
    >
      <div
        class="outline-none focus:outline-none text-center text-base text-white font-semibold"
        :style="
            'font-family:' + (styles.button.text.fontFamily || '') + ';' +
            'text-shadow:' + (styles.button.text.textShadow || '') + ';' +
            'font-size:' + styles.button.text.fontSize + 'px;' +
            'text-align:' + styles.button.text.textAlign + ';' +
            'font-style:' + (styles.button.text.fontStyle || '') + ';' +
            'font-weight:' + (styles.button.text.fontWeight || '') + ';' +
            'letter-spacing:' + (styles.button.text.letterSpacing || '') + ';' +
            'line-height:' + (styles.button.text.lineHeight || '') + ';' +
            '-webkit-text-stroke-width:' + (styles.button.text.textStrokeWidth || '') + ';' +
            '-webkit-text-stroke-color:' + (styles.button.text.textStrokeColor || '') + ';' +
            'text-decoration-line:' + (styles.button.text.textDecorationLine || '') + ';' +
            'color:' + styles.button.text.color + ';'
        "
        @focusout="onLabelChange"
        :contenteditable="editable"
      >
        {{ localValue }}
      </div>
      <div
        type="text"
        class="block outline-none focus:outline-none text-center text-base text-white font-semibold"
        style="background:none"
        :style="
            'margin:' + styles.sublabel.margin + 'px;' +
            'padding: ' + styles.sublabel.padding.join('px ') + 'px;' +
            'margin: ' + styles.sublabel.margin.join('px ') + 'px;' +
            'font-family:' + (styles.sublabel.text.fontFamily || '') + ';' +
            'text-shadow:' + (styles.sublabel.text.textShadow || '') + ';' +
            'font-size:' + styles.sublabel.text.fontSize + 'px;' +
            'text-align:' + styles.sublabel.text.textAlign + ';' +
            'font-style:' + (styles.sublabel.text.fontStyle || '') + ';' +
            'font-weight:' + (styles.sublabel.text.fontWeight || '') + ';' +
            'letter-spacing:' + (styles.sublabel.text.letterSpacing || '') + ';' +
            'line-height:' + (styles.sublabel.text.lineHeight || '') + ';' +
            '-webkit-text-stroke-width:' + (styles.sublabel.text.textStrokeWidth || '') + ';' +
            '-webkit-text-stroke-color:' + (styles.sublabel.text.textStrokeColor || '') + ';' +
            'text-decoration-line:' + (styles.sublabel.text.textDecorationLine || '') + ';' +
            'color:' + styles.sublabel.text.color + ';' +
            styles.sublabel.customStyles ?? ''
        "
        @focusout="onSubLabelChange"
        :contenteditable="editable"
        v-if="localSublabel"
      >
        {{ localSublabel }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FormHeading',
  props: {
    editable: {
      required: true,
    },
    value: {
      required: true,
    },
    sublabel: {
      required: false,
    },
    styles: {
      required: true,
    },
  },
  computed: {
    localSublabel: {
      get: function () {
        return this.sublabel;
      },
      set: function (val) {
        this.$emit('update:sublabel', val);
      }
    },
    localValue: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    onLabelChange(e) {
      this.localValue = e.target.innerText;
    },
    onSubLabelChange(e) {
      this.localSublabel = e.target.innerText;
    },
  }
}
</script>
